import { connect } from 'react-redux';
import { actions } from '../../../../../redux/modules/tipos_vehiculo/tipos_vehiculo';
import VehiculosList from './TiposVehiculo';


const ms2p = (state) => {
  return {
    ...state.tipos_vehiculo,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(VehiculosList);
